// Get the modal
var modal = document.getElementById("myModal");
var span = document.getElementsByClassName("fb-qv-close")[0];
// When the user clicks on <span> (x), close the modal
if (span && modal) {
  span.onclick = function() {
    modal.style.display = "none";
  }
}
// When the user clicks anywhere outside of the modal, close it
if (modal) {
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  }
}

$(document).on('click','.quick-view-btn',function(){
  setTimeout(function(){
     modal.style.display = "block";
  },600);
});

setTimeout(function(){
  var btns = document.querySelectorAll('.quick-view-btn');
      btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var handle = this.getAttribute('data-handle');
        //console.log(handle, 'fdsffdsfsd');
         quick_view_fcn(handle); 
          setTimeout(function(){ 
            $(".slick-slider").slick("refresh");
            $(document).on('submit','#quickViewAddToCartForm',function(e){
              e.preventDefault();
              quickViewAddToCart();
            });
          },600);
      })
  })
}, 1500);

function quick_view_fcn(product_handle){
      const xhttp = new XMLHttpRequest();
      xhttp.onload = function() {
        //var product = JSON.parse(this.response);
        $('#quick-view-box-content').html(this.response);
        
         var moreBtn = document.getElementById('qv-show-more');
         var moreContent = document.getElementById('qv-more-content');
         
         var lessContent = document.getElementById('qv-less-content');
         var lessBtn = document.getElementById('qv-show-less');
        
        if(moreBtn){ 
         moreBtn.style.display = "block";
         lessBtn.style.display = "none"
         moreContent.style.display = "none";
         lessContent.style.display = "block";
        
        moreBtn.addEventListener('click', function() {
           moreContent.style.display = "block";
           lessContent.style.display = "none";
           this.style.display = "none";
           lessBtn.style.display = "block";
        })
        
        lessBtn.addEventListener('click', function() {
           lessContent.style.display = "block";
           moreContent.style.display = "none";
           this.style.display = "none";
           moreBtn.style.display = "block";
        })
        }
        $('#qv-product-images').not('.slick-initialized').slick({
                   dots: true,
                   slidesToShow: 1,
                   slidesToScroll: 1,
                   arrows: false,
                   fade: true,
         });
        
        
      }
      xhttp.open("GET", '/products/' + product_handle + '?view=quickview');
      xhttp.send();
} 




function quickViewAddToCart(){
     $('.loading-overlay-spinner-qv').removeClass('hidden');
     var id = document.getElementById('qv-product-first-variant-id').value;
     var quantity = document.getElementById('quantityQuickView').value;
     if(window.location.href.indexOf("cart") > -1){
  $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: quantity,
          id: id
        },
          dataType: 'json', 
          success: function (data) { 
           window.location.href = '/cart';
           
            setTimeout(function(){
              $('.loading-overlay-spinner-qv').addClass('hidden');
              //modal.style.display = "none";
            },0);
          } 
  });  }
  else {
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: quantity,
          id: id
        },
          dataType: 'json', 
          success: function (data) { 
            openCartSidebar();
            setTimeout(function(){
              $('.loading-overlay-spinner-qv').addClass('hidden');
              //modal.style.display = "none";
            },0);
          } 
  });  }
} 



